<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11">
          <ul class="breadcrumb breadcrumb-style">
            <li class="breadcrumb-item">
              <h4 class="page-title">Fill Prescription</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/pharmacist/dashboard">
                <i class="fas fa-home"></i> Home</a
              >
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a
                routerLink="/pharmacist/prescription/list"
                onClick="return false;"
                >Prescription</a
              >
            </li>
            <li class="breadcrumb-item active">Fill Prescription</li>
          </ul>
        </div>
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1">
          <a
            (click)="back()"
            class="btn btn-group-lg btn-outline-secondary float-end"
          >
            <i class="fa fa-clear"></i> Back
          </a>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="card">
          <div class="body">
            <div class="row">
              <div class="col-md-12">
                <div class="white-box">
                  <!-- <h3>
                      <b>INVOICE</b>
                      <span class="pull-right">#345766</span>
                    </h3>
                    <hr /> -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="pull-left">
                        <img
                          src="assets/images/prescription.png"
                          alt="logo"
                          class="logo-default"
                          height="100"
                        />
                      </div>
                      <div class="pull-right text-end">
                        <address>
                          <p class="font-24 font-bold m-0">
                            {{prescriptionDetails?.Doctor?.PracticeName}}
                          </p>
                          <p class="font-weight-500 m-0">
                            Dr.
                            {{this.prescriptionDetails.doctorUserAccount?.FirstName}}&nbsp;{{this.prescriptionDetails.doctorUserAccount?.LastName}}
                          </p>
                          <p class="text-muted m-0 m-l-30">
                            {{this.prescriptionDetails.doctorUserAccount?.AddressLine1}}
                            <br />
                            {{this.prescriptionDetails.doctorUserAccount?.AddressLine2}}
                          </p>
                          <p class="text-muted m-l-30">
                            Phone No:
                            {{this.prescriptionDetails?.doctorUserAccount?.Phone}}
                          </p>
                        </address>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="pull-left">
                        <p class="addr-font-h3 font-bold">Patient Details</p>
                        <p class="text-muted m-l-5">
                          Name :&nbsp;
                          {{prescriptionDetails?.Patient?.FirstName}}&nbsp;{{prescriptionDetails?.Patient?.LastName}}
                          P-{{prescriptionDetails?.Prescription?.PrescriptionNo}}<br />
                          Gender : {{ prescriptionDetails?.patient?.Gender !=
                          ''?(prescriptionDetails?.patient?.Gender ==
                          'M'?'Male':'Female'):' -' }}<br />
                          Age : {{ prescriptionDetails?.Patient?.Age }}<br />
                          Phone : {{ prescriptionDetails?.Patient?.Phone !=
                          null? prescriptionDetails?.Patient?.Phone:' -'}}
                        </p>
                      </div>
                      <div class="pull-right">
                      </div>
                    </div>
                    <div class="col-md-12 m-0">
                      <div class="pull-right">
                        <select class="selectlist" [(ngModel)]="collectionLocation" (change)="clicktoconver()"  placeholder="Select Collection Locations">
                          <option class="dropdown-item" selected disabled value="undefined">Select collection Location</option>
                          <option  *ngFor="let collection of collectionLocationList;let i = index" 
                          value={{collection.key}}:{{collection.value}}>{{collection.value}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="table-responsive m-t-40">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th class="text-center">Sr. No.</th>
                              <th>Drug</th>
                              <th class="">Description</th>
                              <th class="">#Refill</th>
                              <th class="">Status</th>
                              <th class="">Remark</th>
                              <th class="">
                                Replacement Information
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let drug of this.prescriptionDetails.drugList;let i = index">
                              <td class="text-center">{{i+1}}</td>
                              <td>
                                {{drug?.DrugName}}
                                <p class="font-11 font-italic">
                                  {{drug?.Manufacturer}}
                                </p>
                              </td>
                              <td>{{drug?.Description}}</td>
                              <td>
                                {{(drug?.Refill == null || drug?.Refill ==
                                ''?'-':drug?.Refill)}}
                              </td>
                              <!-- <td>{{drug?.Status}}</td> -->
                              <td>
                                <select class="selectlist"
                                  ngDefaultControl
                                  [(ngModel)]="drug.Status"
                                >
                                  <option value="FILLED">FILLED</option>
                                  <option value="PARTIALLY FILLED"
                                    >PARTIALLY FILLED</option
                                  >
                                  <option value="NOT AVAILABLE"
                                    >NOT AVAILABLE</option
                                  >
                                  <!-- <option value="INPREGRESS">INPREGRESS</option> -->
                                  <option value="PENDING">PENDING</option>
                                </select>
                              </td>
                              <!-- <td
                                *ngIf="prescriptionDetails.Prescription?.IsReadyToCollect == true"
                              >
                                <option
                                  ngDefaultControl
                                  [(ngModel)]="drug.Status"
                                  >{{drug.Status}}</option
                                >
                              </td> -->

                              <td>
                                <span
                                  *ngIf="GetRemark(drug.DrugId) == undefined"
                                  >-</span
                                >
                                <span
                                  *ngIf="GetRemark(drug.DrugId) != undefined"
                                  matTooltip="{{GetRemark(drug.DrugId).Remark}}"
                                  matTooltipPosition="left"
                                >
                                  {{ (GetRemark(drug.DrugId).Remark?.length>22)?
                                  (GetRemark(drug.DrugId).Remark |
                                  slice:0:22)+'..':(GetRemark(drug.DrugId).Remark)
                                  }}
                                </span>
                              </td>
                              <td style="min-width: 150px;">
                                <!-- <a
                                  [hidden]="isReplaceDrugExist(drug.DrugId) != undefined 
                                  "
                                  style="cursor: pointer;"
                                  class="text-primary"
                                  (click)="replacementModal(drug)"
                                  >Replace &nbsp;</a
                                > -->

                                <a
                                  style="
                                    cursor: pointer;
                                    border-left: 1px solid #ccc;
                                    padding-left: 10px;
                                  "
                                  class="text-primary"
                                  (click)="replacementModal(drug)"
                                  >Replace&nbsp;</a
                                >

                                <a
                                  *ngIf="isReplaceDrugExist(drug.DrugId) != undefined && 
                                  IsDrugExist(drug.DrugId) == undefined"
                                  style="
                                    cursor: pointer;
                                    border-left: 1px solid #ccc;
                                    padding-left: 10px;
                                  "
                                  class="text-primary"
                                  (click)="summaryModal(drug)"
                                  >Summary</a
                                >
                                <a
                                  *ngIf="IsDrugExist(drug.DrugId) != undefined"
                                  style="
                                    cursor: pointer;
                                    border-left: 1px solid #ccc;
                                    padding-left: 10px;
                                  "
                                  class="text-primary"
                                  (click)="summaryModalView(drug)"
                                  >Summary</a
                                >
                              </td>
                              <!-- <td
                                *ngIf="prescriptionDetails.Prescription?.IsReadyToCollect == true"
                              >
                                -&nbsp;&nbsp;&nbsp;
                                <a
                                  *ngIf="IsDrugExist(drug.DrugId) != undefined"
                                  style="cursor: pointer;"
                                  class="text-primary"
                                  (click)="summaryModalView(drug)"
                                  >Summary</a
                                >
                              </td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div
                        class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pull-left"
                      >
                        <p class="">
                          <i class="fa fa-calendar"></i><b> &emsp;Date :</b>
                          {{currentDate | date:'MM-dd-yyyy'}}
                        </p>
                      </div>

                      <!-- <div class="col-xs-2 col-sm-2 col-md-3 col-lg-3"></div> -->

                      <div
                        class="col-xs-5 col-sm-5 col-md-5 col-lg-5 pull-right"
                      >
                        <div class="pull-right text-center">
                          <div class="col ml-5 float-left form-section p-0">
                            <div class="signature-wrapper">
                              <img
                                [src]="prescriptionDetails.Prescription?.Signature"
                                class="border-radius-5"
                                style="box-shadow: 0 0px 2px #212529;"
                                alt=""
                              />
                              <br />
                              <span>Signature</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <h5 class="">Comments:</h5>
                      <textarea
                        [(ngModel)]="comments"
                        name=""
                        id=""
                        class="col-md-12"
                        rows="5"
                        [maxLength]="300"
                      ></textarea>
                      <!-- <p
                        *ngIf="prescriptionDetails.Prescription?.IsReadyToCollect == true"
                      >
                        {{prescriptionDetails.Prescription?.Comment}}
                      </p> -->
                    </div>

                    <div class="col-md-12">
                      <div class="justify-content-end row">
                        <button
                          *ngIf="!(prescriptionDetails.Prescription?.IsReadyToCollect == true)"
                          style="width: fit-content;"
                          class="btn btn-lg btn-primary m-r-10"
                          (click)="ReadyToCollect()"
                          type="button"
                          [disabled]="prescriptionDetails.Prescription?.IsReadyToCollect == true"
                        >
                          Ready To Collect
                        </button>
                        <button
                          *ngIf="!(prescriptionDetails.Prescription?.IsReadyToCollect == true)"
                          style="width: fit-content;"
                          class="btn btn-lg btn-secondary m-r-10"
                          (click)="back()"
                          [disabled]="prescriptionDetails.Prescription?.IsReadyToCollect == true"
                          type="button"
                        >
                          Cancel
                        </button>
                        <button
                          *ngIf="!(prescriptionDetails.Prescription?.IsReadyToCollect == false 
                        || prescriptionDetails.Prescription?.IsReadyToCollect == undefined)"
                          style="width: fit-content;"
                          class="m-r-10 mr-3 btn btn-success"
                          type="button"
                          (click)="printPrescription()"
                          [disabled]="prescriptionDetails.Prescription?.IsReadyToCollect == false 
                            || prescriptionDetails.Prescription?.IsReadyToCollect == undefined">
                          Print Prescription
                        </button>

                        <button
                          *ngIf="!(prescriptionDetails.Prescription?.IsReadyToCollect == false 
                        || prescriptionDetails.Prescription?.IsReadyToCollect == undefined)"
                          style="width: fit-content;"
                          class="m-r-10 mr-3 btn btn-success"
                          type="button"
                          (click)="Collected()"
                          [disabled]="prescriptionDetails.Prescription?.IsReadyToCollect == false 
                            || prescriptionDetails.Prescription?.IsReadyToCollect == undefined"
                        >
                          Collected
                        </button>
                        <button
                          *ngIf="!(prescriptionDetails.Prescription?.IsReadyToCollect == false 
                        || prescriptionDetails.Prescription?.IsReadyToCollect == undefined)"
                          style="width: fit-content;"
                          class="m-r-10 mr-3 btn btn-danger"
                          type="button"
                          (click)="NotCollected()"
                          [disabled]="prescriptionDetails.Prescription?.IsReadyToCollect == false 
                          || prescriptionDetails.Prescription?.IsReadyToCollect == undefined"
                        >
                          Not Collected
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #CancelPrescriptionComponent>
  <div class="row delete-confirm">
    <div class="col-sm-12 mb-3">
      Do you want to cancel filling prescription <br />
      <span class="text-info"
        >{{ prescriptionDetails?.Prescription?.PrescriptionNo }}</span
      >&nbsp;?
    </div>
    <div class="col-sm-12">
      <div class="row">
        <div class="col-sm-10">
          <button
            type="button"
            (click)="ChangePrescriptionStatus(prescriptionDetails.Prescription,oldStatus)"
            class="btn btn-sm btn-primary me-3"
          >
            Yes
          </button>
          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary"
          >
            No
          </button>
          <!-- <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-sm btn-secondary me-5"
          >
            Close
          </button> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #printPrescriptionConfirm class="newprint">
  <div style="display: flex;
  align-items: center;
  justify-content: center;
  height: 199px;">
    <div class="row delete-confirm ">
      <div class="col-sm-12 mb-3 ">
        Are you handing over the presecription to patient
      </div>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-5">
            <button
              type="button"
              (click)="prescriptionStatusChange(prescriptionDetails)"
              class="btn btn-sm btn-primary me-3">
              Yes
            </button>
  
            <button
              type="button"
              (click)="prescriptionNotStatusChange(prescriptionDetails)"
              class="btn btn-sm btn-secondary">
              No
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-3 font-13">
        *Please note, if you are handing over the prescription to patient, it will be assumed that medicines will not be filled at "Hilltop Pharmacy" necessarily and hence it will not be tracked.
      </div>
    </div>
  </div>
</ng-template>
